import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@design-system/box';
import { useTheme } from '@design-system/theme';
export const Container = (_a) => {
    var { children, height, mx, width } = _a, otherProps = __rest(_a, ["children", "height", "mx", "width"]);
    const theme = useTheme();
    const RESPONSIVE_WIDTHS = {
        _: '100%',
        l: theme.breakpoints.l,
        m: theme.breakpoints.m,
        xl: theme.breakpoints.xl,
    };
    return (_jsx(Box, Object.assign({ height: height !== null && height !== void 0 ? height : '100%', justifyContent: "center", maxWidth: width !== null && width !== void 0 ? width : RESPONSIVE_WIDTHS, mx: mx !== null && mx !== void 0 ? mx : 'auto', width: width !== null && width !== void 0 ? width : '100%' }, otherProps, { children: children })));
};
//# sourceMappingURL=Container.js.map